module.exports = require("@swa-ui/core/src/Checkbox/Checkbox.module.scss");